import React, { useState } from 'react';
import { Avatar, Row, ViewLogo, Content, IconButton } from './style';
import { Ionicons, Feather } from '@expo/vector-icons';
import THEME from '../../config/theme';
import { HeaderContainer, SmallText } from '../../config/theme/globalStyles';
import { DrawerActions, useNavigation } from '@react-navigation/native';
import TouchableText from '../../components/TouchableText';
import {
  Modal,
  ScrollView,
  TouchableOpacity,
  useWindowDimensions,
  View,
} from 'react-native';
import {
  aspectRatioLogoAbout,
  aspectRatioLogoMain,
  hasOutsideAboutPage,
} from '../../config/data';
import Button from '../Button';
import { auth, firestore } from '../../services/firebase';
import { signOut } from 'firebase/auth';
import ViewPortProvider from '../../hooks/ViewPortProvider';
import useViewport from '../../hooks/useViewport';
import LogoAbout from '../../../assets/LogoAbout.png';
import LogoMain from '../../../assets/LogoMain.png';
import NotificationModal from './../Modals/NotificationModal';
import { useRemoteConfigContext } from '../../contexts/useRemoteConfigContext';
import { addDoc, collection } from 'firebase/firestore';
import { EditMain } from '../../pages/Main/EditMain';
import { ActivityIndicator, Menu } from 'react-native-paper';
import { useCustomImages } from '../../api/Brand';
import { useCustomTheme } from '../../contexts/useCustomTheme';
import { useDownloadStorageZip } from '../../hooks/useDownloadStorageZip';
import { useImageAspectRatio } from '../../hooks/useImageAspectRatio';

const Header = ({
  about,
  onPressEditProfile,
  onPress,
  user,
  isAdminPage,
  isPageMain,
  onOpenFilters,
  onOpenCatalogSettings,
  hideCommunity,
  searchRouteParams,
}) => {
  const navigation = useNavigation();

  const { customColor, customFont, customInfo } = useCustomTheme();
  const [modalVisible, setModalVisible] = useState(false);
  const [visible, setVisible] = React.useState(false);
  const openMenu = () => setVisible(true);
  const closeMenu = () => setVisible(false);

  const [title, setTitle] = useState('');
  const [content, setContent] = useState('');
  const [loading, setLoading] = useState(false);
  //adminRole "supportOnly" only allows access to notiications, community and comments
  const hasAdminRole = !user?.adminRole

  const config = useRemoteConfigContext();
  const hasGeneralNotifications = config.hasGeneralNotifications;
  const hasCommunity = config.hasCommunity;

  const { data: logo, isLoading: isLoadingLogo } = useCustomImages('logoApp');
  const { downloading, progress, downloadStorageAsZip, cancelDownload } = useDownloadStorageZip();

  const { width: windowWidth } = useWindowDimensions();
  const isSmallScreen = windowWidth < 768;

  // ── Tokens de tamanho do header ───────────────────────────────────────────
  // Um único conjunto para TODOS os ícones: antes o menu (34) e os ícones de
  // ação (30) usavam números soltos, o que deixava a linha irregular e apertada
  // no celular. O menu é um glifo mais "leve" que os outlines, então continua
  // um ponto acima para pesar igual.
  const iconSize = isSmallScreen ? 24 : 28;
  const menuIconSize = isSmallScreen ? 26 : 30;
  const headerRowHeight = isSmallScreen ? 2.5 : 3; // rem

  // Logo do app (Main) = mais um ícone da linha, com uma caixa um pouco maior
  // que a dos demais: logo costuma vir com margem transparente embutida no
  // arquivo, então na mesma caixa dos ícones a arte apareceria menor que eles.
  //
  // Dentro dessa caixa a arte é medida pela proporção REAL: assim ela encosta
  // nas bordas da caixa em vez de ficar centralizada com faixa vazia em volta
  // — era essa faixa que deixava o logo mais afastado da borda direita do que
  // o ícone de menu está da esquerda. Também garante que nenhum formato de
  // logo (cada cliente sobe o seu) estoure a largura do header.
  const mainLogoSource = logo ? logo.url : LogoMain;
  const mainLogoRatio = useImageAspectRatio(
    mainLogoSource,
    Number(aspectRatioLogoMain) || 1
  );
  const mainLogoBox = Math.round(iconSize * 1.4); // 34 no celular, 39 no desktop
  const mainLogoWidth =
    mainLogoRatio >= 1 ? mainLogoBox : mainLogoBox * mainLogoRatio;
  const mainLogoHeight =
    mainLogoRatio >= 1 ? mainLogoBox / mainLogoRatio : mainLogoBox;

  const handleCloseModal = () => {
    setModalVisible(false);
  };

  const handleSendNotification = async () => {
    const notificationData = {
      title,
      body: content,
      sendDate: new Date(),
      status: 'pending',
      type: 'schedulingAdmin',
    };

    try {
      setLoading(true);
      const notificationsRef = collection(firestore, 'notifications');
      await addDoc(notificationsRef, notificationData);
      handleCloseModal();
      setTitle('');
      setContent('');
    } catch (error) {
      console.error('Erro ao enviar a notificação:', error);
    } finally {
      setLoading(false);
    }
  };

  const drawerIconColor = isAdminPage ? "black" :
    customColor && customColor.iconsMain && customColor.iconsMain.icons
      ? customColor.iconsMain.icons
      : THEME.COLORS.ICON_HEADER_MAIN;

  const handleToggleDrawer = () => {
    navigation.dispatch(DrawerActions.toggleDrawer());
  };

  const logout = () => {
    signOut(auth)
      .then(() => {
        window.location.assign('../About');
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const MobileOrDesktopComponent = () => {
    const { width } = useViewport();
    const breakpoint = 1080;
    return width < breakpoint ? (
      <HeaderContainer
        flexDirection="column"
        justifyContent="center"
        alignItems="center"
        pointerEvents="box-none"
      >
        <ViewLogo>
          {isLoadingLogo ? (
            <ActivityIndicator
              style={{
                flex: 1,
                justifyContent: 'center',
              }}
              color={
                customColor && customColor.primary
                  ? customColor.primary
                  : THEME.COLORS.PRIMARY_800
              }
            />
          ) : (
            <Avatar
              resizeMode="contain"
              width={`${aspectRatioLogoAbout * 48}px`}
              source={logo ? logo.url : LogoAbout}
            />
          )}
        </ViewLogo>
        <Content>
          {user ? (
            <>
              <View style={{ marginRight: '1rem' }}>
                <Button
                  title={'Acessar conteúdo'}
                  colorbutton={THEME.COLORS.S1_BUTTON_HEADER}
                  onPress={onPress}
                  colortitle={THEME.COLORS.S1_HEADER_CONTENT}
                  fontFamily={THEME.FONTFAMILY.REGULAR}
                  fontSize={THEME.FONTSIZE.SMALL}
                  padding="0.3rem"
                ></Button>
              </View>
              <Button
                title={'Sair'}
                colorbutton="transparent"
                colortitle={THEME.COLORS.S1_HEADER_LOGIN}
                onPress={logout}
                fontFamily={THEME.FONTFAMILY.REGULAR}
                fontSize={THEME.FONTSIZE.SMALL}
                padding="0.3rem"
              ></Button>
            </>
          ) : (
            <>
              <View style={{ marginRight: '1rem' }}>
                <Button
                  title={'Visualizar Conteúdo'}
                  colortitle={THEME.COLORS.S1_HEADER_CONTENT}
                  colorbutton={THEME.COLORS.S1_BUTTON_HEADER}
                  onPress={onPress}
                  fontFamily={THEME.FONTFAMILY.REGULAR}
                  fontSize={THEME.FONTSIZE.SMALL}
                  padding="0.3rem"
                ></Button>
              </View>
              <Button
                title={'Login'}
                colorbutton="transparent"
                colortitle={THEME.COLORS.S1_HEADER_LOGIN}
                onPress={() => navigation.navigate('Login')}
                fontFamily={THEME.FONTFAMILY.REGULAR}
                fontSize={THEME.FONTSIZE.SMALL}
                padding="0.3rem"
              ></Button>
            </>
          )}
        </Content>
      </HeaderContainer>
    ) : (
      <HeaderContainer pointerEvents="box-none">
        <Row height={3}>
          {isLoadingLogo ? (
            <ActivityIndicator
              style={{
                flex: 1,
                backgroundColor: 'THEME.COLORS.BACKGROUND_ABOUT',
                justifyContent: 'center',
              }}
              color={
                customColor && customColor.primary
                  ? customColor.primary
                  : THEME.COLORS.PRIMARY_800
              }
            />
          ) : (
            <Avatar
              resizeMode="contain"
              width={`${aspectRatioLogoAbout * 48}px`}
              source={logo ? logo.url : LogoAbout}
            />
          )}
        </Row>
        <Row height={3}>
          {user ? (
            <>
              <View style={{ marginRight: '1rem' }}>
                <Button
                  title={'Acessar conteúdo'}
                  colorbutton={THEME.COLORS.S1_BUTTON_HEADER}
                  colortitle={THEME.COLORS.S1_HEADER_CONTENT}
                  onPress={onPress}
                  fontFamily={THEME.FONTFAMILY.REGULAR}
                  fontSize={THEME.FONTSIZE.SMALL}
                  padding="0.3rem"
                ></Button>
              </View>
              <Button
                title={'Sair'}
                colortitle={THEME.COLORS.S1_HEADER_LOGIN}
                colorbutton="transparent"
                onPress={logout}
                fontFamily={THEME.FONTFAMILY.REGULAR}
                fontSize={THEME.FONTSIZE.SMALL}
                padding="0.3rem"
              ></Button>
            </>
          ) : (
            <>
              <View style={{ marginRight: '1rem' }}>
                <Button
                  title={'Visualizar Conteúdo'}
                  colorbutton={THEME.COLORS.S1_BUTTON_HEADER}
                  colortitle={THEME.COLORS.S1_HEADER_CONTENT}
                  onPress={onPress}
                  fontFamily={THEME.FONTFAMILY.REGULAR}
                  fontSize={THEME.FONTSIZE.SMALL}
                  padding="0.3rem"
                ></Button>
              </View>
              <Button
                title={'Login'}
                colorbutton="transparent"
                colortitle={THEME.COLORS.S1_HEADER_LOGIN}
                onPress={() => navigation.navigate('Login')}
                fontFamily={THEME.FONTFAMILY.REGULAR}
                fontSize={THEME.FONTSIZE.SMALL}
                padding="0.3rem"
              ></Button>
            </>
          )}
        </Row>
      </HeaderContainer>
    );
  };

  return user?.isAdmin ? (
    <HeaderContainer pointerEvents="box-none">
      <Row height={headerRowHeight}>
        {onPress ? (
          <Row>
            <Feather
              name="chevron-left"
              color={
                customColor && customColor.text && customColor.text.app
                  ? customColor.text.app
                  : THEME.COLORS.ICON_HEADER_CLICKCLASS
              }
              size={
                customFont && customFont.fontLX
                  ? customFont.fontLX
                  : THEME.FONTSIZE.BIG
              }
              onPress={onPress}
            />
            <TouchableText
              onPress={onPress}
              title={'Voltar'}
              fontFamily={
                customFont && customFont.fontFamilyText
                  ? customFont.fontFamilyText
                  : THEME.FONTFAMILY.REGULAR
              }
              color={
                customColor && customColor.text && customColor.text.app
                  ? customColor.text.app
                  : THEME.COLORS.ICON_HEADER_CLICKCLASS
              }
            ></TouchableText>
          </Row>
        ) : (
          <Feather
            name="menu"
            color={drawerIconColor}
            size={menuIconSize}
            onPress={handleToggleDrawer}
          />
        )}
      </Row>

      <Row height={headerRowHeight}>
        {about && (
          <>
            {/* Header da About: aqui o logo é a marca da página, não um ícone
                da barra — segue no tamanho de sempre. */}
            <TouchableOpacity style={{ height: '3rem' }} onPress={onPress}>
              {aspectRatioLogoMain?.length > 0 && (
                <Avatar
                  resizeMode="contain"
                  source={LogoMain}
                  width={`${aspectRatioLogoMain * 48}px`}
                />
              )}
            </TouchableOpacity>
          </>
        )}
        {isPageMain && (
          <View
            style={{
              flexDirection: 'row',
              alignItems: 'center',
              gap: isSmallScreen ? 4 : 12,
            }}
          >
            {customInfo?.downloadMaterials === true && (
              <IconButton
                compact={isSmallScreen}
                onPress={downloading ? cancelDownload : downloadStorageAsZip}
                style={{ opacity: downloading ? 0.7 : 1 }}
              >
                {downloading ? (
                  <ActivityIndicator size={iconSize} color={drawerIconColor} />
                ) : (
                  <Ionicons
                    name={'download-outline'}
                    size={iconSize}
                    color={drawerIconColor}
                  />
                )}
                {!isSmallScreen && (
                  <SmallText
                    style={{
                      fontFamily:
                        customFont && customFont.fontFamilyText
                          ? customFont.fontFamilyText
                          : THEME.FONTFAMILY.REGULAR,
                      maxWidth: 200,
                    }}
                    numberOfLines={1}
                    color={drawerIconColor}
                    padding="0rem 0.3rem"
                  >
                    {downloading ? (progress || 'Baixando...') : 'Exportar'}
                  </SmallText>
                )}
              </IconButton>
            )}
            {hasAdminRole &&
              <IconButton
                compact={isSmallScreen}
                onPress={() => {
                  onOpenFilters()
                }}
              >
                <Ionicons
                  name={'filter-outline'}
                  size={iconSize}
                  color={drawerIconColor}
                />
                {!isSmallScreen && (
                  <SmallText
                    style={{
                      fontFamily:
                        customFont && customFont.fontFamilyText
                          ? customFont.fontFamilyText
                          : THEME.FONTFAMILY.REGULAR,
                    }}
                    color={drawerIconColor}
                    padding="0rem 0.3rem"
                  >
                    Filtros
                  </SmallText>
                )}
              </IconButton>
            }
            {hasAdminRole &&
              <IconButton
                compact={isSmallScreen}
                onPress={() => {
                  onOpenCatalogSettings?.();
                }}
              >
                <Ionicons
                  name={'settings-outline'}
                  size={iconSize}
                  color={drawerIconColor}
                />
                {!isSmallScreen && (
                  <SmallText
                    style={{
                      fontFamily:
                        customFont && customFont.fontFamilyText
                          ? customFont.fontFamilyText
                          : THEME.FONTFAMILY.REGULAR,
                    }}
                    color={drawerIconColor}
                    padding="0rem 0.3rem"
                  >
                    Catálogo
                  </SmallText>
                )}
              </IconButton>
            }
            {hasAdminRole &&
              (() => {
                const brushButton = (
                  <IconButton
                    compact={isSmallScreen}
                    onPress={() => {
                      openMenu()
                    }}
                  >
                    <Ionicons
                      name={'brush-outline'}
                      size={iconSize}
                      color={drawerIconColor}
                    />
                    {!isSmallScreen && (
                      <SmallText
                        style={{
                          fontFamily:
                            customFont && customFont.fontFamilyText
                              ? customFont.fontFamilyText
                              : THEME.FONTFAMILY.REGULAR,
                        }}
                        color={drawerIconColor}
                        padding="0rem 0.3rem"
                      >
                        Edição
                      </SmallText>
                    )}
                  </IconButton>
                );

                // No celular o painel NÃO pode ser um Menu do Paper: o menu é
                // ancorado no ícone (canto superior direito) e o conteúdo, com
                // ~94vw de largura, escapava pela borda esquerda da tela — era
                // isso que cortava o "Personalização". Vira uma folha que sobe
                // de baixo, ocupando a largura inteira e rolando por dentro.
                if (isSmallScreen) {
                  return (
                    <>
                      {brushButton}
                      <Modal
                        visible={visible}
                        transparent
                        animationType="fade"
                        onRequestClose={closeMenu}
                      >
                        <View
                          style={{
                            flex: 1,
                            justifyContent: 'flex-end',
                            backgroundColor: 'rgba(0,0,0,0.45)',
                          }}
                        >
                          <View
                            style={{
                              maxHeight: '92%',
                              backgroundColor: '#FFFFFF',
                              borderTopLeftRadius: 16,
                              borderTopRightRadius: 16,
                              overflow: 'hidden',
                            }}
                          >
                            <ScrollView>
                              <EditMain closeMenu={closeMenu} fullWidth />
                            </ScrollView>
                          </View>
                        </View>
                      </Modal>
                    </>
                  );
                }

                return (
                  <Menu visible={visible} anchor={brushButton}>
                    <EditMain closeMenu={closeMenu} />
                  </Menu>
                );
              })()
            }
          </View>
        )}

        {hasGeneralNotifications && !isAdminPage && isPageMain && (
          <>
            <IconButton
              compact={isSmallScreen}
              onPress={() => {
                navigation.navigate('Notifications');
              }}
            >
              <Ionicons
                name={'notifications-outline'}
                size={iconSize}
                color={drawerIconColor}
              />
              {!isSmallScreen && (
                <SmallText
                  style={{
                    fontFamily:
                      customFont && customFont.fontFamilyText
                        ? customFont.fontFamilyText
                        : THEME.FONTFAMILY.REGULAR,
                  }}
                  color={drawerIconColor}
                  padding="0rem 0.3rem"
                >
                  Notificações
                </SmallText>
              )}
            </IconButton>

            <NotificationModal
              modalVisible={modalVisible}
              handleCloseModal={handleCloseModal}
              handleSendNotification={handleSendNotification}
              loading={loading}
              setTitle={setTitle}
              setContent={setContent}
              title={title}
              content={content}
            />
          </>
        )}
        {hasCommunity && !isAdminPage && isPageMain && !hideCommunity && (
          <IconButton
            compact={isSmallScreen}
            onPress={() => {
              navigation.navigate('Community');
            }}
          >
            <Ionicons name="laptop-outline" size={iconSize} color={drawerIconColor} />
            {!isSmallScreen && (
              <SmallText
                style={{
                  fontFamily:
                    customFont && customFont.fontFamilyText
                      ? customFont.fontFamilyText
                      : THEME.FONTFAMILY.REGULAR,
                }}
                color={drawerIconColor}
                padding="0rem 0.3rem"
              >
                Comunidade
              </SmallText>
            )}
          </IconButton>
        )}

        {aspectRatioLogoMain?.length > 0 && (
          <Avatar
            resizeMode="contain"
            source={mainLogoSource}
            width={`${mainLogoWidth}px`}
            height={`${mainLogoHeight}px`}
          />
        )}
      </Row>
    </HeaderContainer>
  ) : about ? (
    <ViewPortProvider>
      <MobileOrDesktopComponent />
    </ViewPortProvider>
  ) : (
    <HeaderContainer pointerEvents="box-none">
      <Row height={headerRowHeight}>
        {onPress ? (
          <Row>
            <Feather
              name="chevron-left"
              color={
                customColor && customColor.text && customColor.text.app
                  ? customColor.text.app
                  : THEME.COLORS.ICON_HEADER_CLICKCLASS
              }
              size={
                customFont && customFont.fontLX
                  ? customFont.fontLX
                  : THEME.FONTSIZE.BIG
              }
              onPress={onPress}
            />
            <TouchableText
              onPress={onPress}
              title={'Voltar'}
              fontFamily={
                customFont && customFont.fontFamilyText
                  ? customFont.fontFamilyText
                  : THEME.FONTFAMILY.REGULAR
              }
              color={
                customColor && customColor.text && customColor.text.app
                  ? customColor.text.app
                  : THEME.COLORS.ICON_HEADER_CLICKCLASS
              }
            ></TouchableText>
          </Row>
        ) : onPressEditProfile ? (
          <Row>
            <Feather
              name="chevron-left"
              color={
                customColor && customColor.text && customColor.text.auth
                  ? customColor.text.auth
                  : THEME.COLORS.ICON_HEADER
              }
              size={
                customFont && customFont.fontLX
                  ? customFont.fontLX
                  : THEME.FONTSIZE.BIG
              }
              // Este ramo é escolhido justamente por NÃO haver `onPress` — a
              // seta ficava sem ação nenhuma enquanto o texto ao lado voltava.
              onPress={onPressEditProfile}
            />
            <TouchableText
              onPress={onPressEditProfile}
              title={'Voltar'}
              fontFamily={
                customFont && customFont.fontFamilyText
                  ? customFont.fontFamilyText
                  : THEME.FONTFAMILY.REGULAR
              }
              color={
                customColor && customColor.text && customColor.text.auth
                  ? customColor.text.auth
                  : THEME.COLORS.ICON_HEADER
              }
            ></TouchableText>
          </Row>
        ) : (
          <Feather
            name="menu"
            color={drawerIconColor}
            size={menuIconSize}
            onPress={() => navigation.dispatch(DrawerActions.toggleDrawer())}
          />
        )}
      </Row>

      {isPageMain && (
        <View
          style={{
            height: `${headerRowHeight}rem`,
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <IconButton
            compact={isSmallScreen}
            onPress={() => {
              navigation.navigate('Buscar', searchRouteParams || undefined);
            }}
          >
            <Ionicons
              name="ios-search-outline"
              size={iconSize}
              color={
                customColor &&
                  customColor.iconsMain &&
                  customColor.iconsMain.icons
                  ? customColor.iconsMain.icons
                  : THEME.COLORS.ICON_HEADER_MAIN
              }
            />
            {!isSmallScreen && isPageMain && (
              <SmallText
                style={{
                  fontFamily:
                    customFont && customFont.fontFamilyText
                      ? customFont.fontFamilyText
                      : THEME.FONTFAMILY.REGULAR,
                }}
                color={drawerIconColor}
                padding="0rem 0.3rem"
              >
                Buscar
              </SmallText>
            )}
          </IconButton>
          {hasCommunity && !hideCommunity && (
            <IconButton
              compact={isSmallScreen}
              onPress={() => {
                navigation.navigate('Community');
              }}
            >
              <Ionicons
                name="laptop-outline"
                size={iconSize}
                color={drawerIconColor}
              />
              {!isSmallScreen && isPageMain && (
                <SmallText
                  style={{
                    fontFamily:
                      customFont && customFont.fontFamilyText
                        ? customFont.fontFamilyText
                        : THEME.FONTFAMILY.REGULAR,
                  }}
                  color={drawerIconColor}
                  padding="0rem 0.3rem"
                >
                  Comunidade
                </SmallText>
              )}
            </IconButton>
          )}
          {/* Altura da linha (e não a da arte) para a área de toque não virar
              uma fita fina quando o logo é largo e baixo. */}
          <TouchableOpacity
            style={{
              height: `${headerRowHeight}rem`,
              width: mainLogoWidth,
              alignItems: 'center',
              justifyContent: 'center',
            }}
            onPress={() => {
              hasOutsideAboutPage ? {} : navigation.navigate('Inicio');
            }}
          >
            {aspectRatioLogoMain?.length > 0 &&
              (isLoadingLogo ? (
                <ActivityIndicator
                  style={{
                    flex: 1,
                    justifyContent: 'center',
                  }}
                  color={
                    customColor && customColor.primary
                      ? customColor.primary
                      : THEME.COLORS.PRIMARY_800
                  }
                />
              ) : (
                <Avatar
                  resizeMode="contain"
                  width={`${mainLogoWidth}px`}
                  height={`${mainLogoHeight}px`}
                  source={mainLogoSource}
                />
              ))}
          </TouchableOpacity>
        </View>
      )}
    </HeaderContainer>
  );
};

export default Header;
